module.exports = __webpack_public_path__ + "static/media/Tischset_45x35_einzel.771e3b37.png";